import { findEnterpriseList } from '@/service/api';
import { IFactoryState, IFactoryTable } from "@/typings/factory";
import { Module } from "vuex";
import { IGlobalState } from "..";
import * as Types from '../action-types';

const state: IFactoryState = {
    keyWord: "",
    factorys: {
        page: 1,
        limit: 10,
        page_count: 0,
        total_rows: 0,
        rows: []
    }
};

const factory: Module<IFactoryState, IGlobalState> = {
    namespaced: true,
    state,
    mutations: {
        [Types.SET_FACTORY_PAGE](state, payload) {
            state.factorys.page = payload;
        },
        [Types.SET_FACTORY_LIST](state, payload: IFactoryTable) {
            state.factorys.rows = payload.rows;
            state.factorys.page_count = payload.page_count;
            state.factorys.total_rows = payload.total_rows;
        }
    
    },
    actions: {
       // 设置厂商列表
       async [Types.SET_FACTORY_LIST]({ commit },params) {
        let result = await findEnterpriseList(params);
        commit(Types.SET_FACTORY_LIST, result.data);
    },
    }
};
export default factory;